module.exports = __webpack_public_path__ + "img/white-calendar-bold-20x20.6990a6c1.svg";